import { useQuery } from '@tanstack/react-query';

import { listPointsPurchaseOfferCampaigns } from '~/services/LuxLoyalty';

import { pointsPurchaseQueryKeys } from './pointsPurchaseQueryKeys';

export function useGetPointsPurchaseOfferCampaigns() {
  return useQuery({
    queryKey: pointsPurchaseQueryKeys.campaigns(),
    queryFn: async () => listPointsPurchaseOfferCampaigns(),
  });
}
